import React, { Component } from "react";
import axios from "axios";
import firebase from "firebase/app";
import Cookies from "js-cookie";
import { BrowserRouter as Router } from "react-router-dom";
import ReactGA from "react-ga";
import { hotjar } from "react-hotjar";
import Loading from "./components/Loading";
import { fullAccessLevels, halfAccessLevels } from "./accessLevels";
import ActionTypes from "./actions/types";
import { connect } from "react-redux";
import { fetchNewsFunc, fetchOpenInterestFunc } from "./Shared";
import Routes from "./routes";
import { fetchGeneralNews } from "./Shared/news";
import { BaseURL } from "./constants";

class App extends Component {
  UNSAFE_componentWillMount() {
    ReactGA.initialize("UA-156092736-2");
    hotjar.initialize(2161405, 6);
  }

  componentDidMount() {
    const { wp_token, tokenExists, logout } = this.props.appState;

    if (wp_token.jwt_token) {
      this.storeTokeninCookies();
      return;
    }

    if (tokenExists) {
      const userData = JSON.parse(
        localStorage.getItem("optionGeeks-user-details")
      );
      this.props.setAppStateAction({
        userData: userData.data,
        tokenExists: userData.token,
      });
      this.membershipLevel(userData);
    } else {
      this.props.setAppStateAction({ loginLoader: true });
      window.location.replace("https://optionsgeek.com/welcome-home-page");
    }

    if (logout === "true") {
      this.props.setAppStateAction({ loginLoader: true });
      this.logoutUser();
    }

    window.addEventListener("resize", this.handleWindowSizeChange);
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // fetchGeneralNews(this.props.setAppStateAction);
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () =>
    this.props.setAppStateAction({ width: window.innerWidth });

  loginCheck = () => {
    const tokenExistInCookies = Cookies.get("token");

    if (
      !tokenExistInCookies &&
      Object.keys(this.props.appState.userData).length
    ) {
      this.props.setAppStateAction({ loginLoader: true });
      window.location.replace("https://optionsgeek.com/wp-login.php");
    }
  };

  membershipLevel = (userData) => {
    const userInformation = userData.data;

    const fullAccess = userInformation.membership.some((mem) =>
      fullAccessLevels.includes(mem.id)
    );
    const halfAccess = userInformation.membership.some((mem) =>
      halfAccessLevels.includes(mem.id)
    );

    if (fullAccess) {
      this.props.setAppStateAction({
        accessLevel: "fullaccess",
        redirectLink: "/optionschain",
      });
    } else if (halfAccess) {
      this.props.setAppStateAction({
        accessLevel: "halfaccess",
        redirectLink: "/unusualoptionsactivity",
      });
    } else {
      console.log("no case found");
      this.props.setAppStateAction({
        accessLevel: "noaccess",
        redirectLink: "/unusualoptionsactivity",
      });
    }
  };

  storeTokeninCookies = async () => {
    try {
      this.props.setAppStateAction({ loginLoader: true });
      const { data } = await axios.post(
        `${BaseURL}/api/sso`,
        this.props.appState.wp_token
      );

      Cookies.set("token", data.token);
      localStorage.setItem("optionGeeks-user-details", JSON.stringify(data));
      localStorage.setItem("isAuthenticated", "true");
      this.props.setAppStateAction({
        userData: data.data,
        tokenExists: data.token,
        loginLoader: false,
      });

      if (this.props.appState.tokenExists) {
        const userData = JSON.parse(
          localStorage.getItem("optionGeeks-user-details")
        );
        const userInformation = userData.data;

        const accessLevels = {
          TheTop1ClubFree: "1578859558",
          threeStepstoProfit: "1578861066",
          WinningPicksAnnual: "1578861151",
          WinningPicksMonthly: "1578861204",
          LiveOptionsSeminar: "1578861223",
          WinningPickseBook: "1607724476",
          TheTop1Club: "1651365143",
          ToolsFull: "1651597226",
          ToolsNOC: "1651597378",
          tools3Steps: "1688674410",
        };

        const fullAccessLevels = [
          accessLevels.ToolsFull,
          accessLevels.WinningPicksMonthly,
          accessLevels.WinningPicksAnnual,
          accessLevels.tools3Steps,
        ];
        const halfAccessLevels = [
          accessLevels.threeStepstoProfit,
          accessLevels.TheTop1Club,
          accessLevels.ToolsNOC,
        ];

        const fullAccess = userInformation.membership.some((mem) =>
          fullAccessLevels.includes(mem.id)
        );
        const halfAccess = userInformation.membership.some((mem) =>
          halfAccessLevels.includes(mem.id)
        );

        if (fullAccess) {
          this.props.setAppStateAction({
            accessLevel: "fullaccess",
            redirectLink: "/optionschain",
          });
        } else if (halfAccess) {
          this.props.setAppStateAction({
            accessLevel: "halfaccess",
            redirectLink: "/unusualoptionsactivity",
          });
        } else {
          console.log("no case found");
          this.props.setAppStateAction({
            accessLevel: "noaccess",
            redirectLink: "/unusualoptionsactivity",
          });
        }

        this.props.setAppStateAction({
          userData: userData.data,
          tokenExists: userData.token,
        });
        this.membershipLevel(userData);
        console.log(this.props.appState.accessLevel);
      } else {
        // this.props.setAppStateAction({ loginLoader: true });
        // window.location.replace('https://optionsgeek.com/welcome-home-page');
      }

      if (this.props.appState.logout === "true") {
        this.props.setAppStateAction({ loginLoader: true });
        this.logoutUser();
      }

      window.addEventListener("resize", this.handleWindowSizeChange);
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          fetchGeneralNews(this.props.setAppStateAction);
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  logoutUser = async () => {
    try {
      const response = await axios.post(
        `${BaseURL}/api/logout?wp_user_id=${this.props.appState.wp_user_id}&token=${this.props.appState.tokenExists}`
      );
      if (response.status === 200) {
        localStorage.clear();
        window.location.replace("https://optionsgeek.com/log-out/");
      }
    } catch (error) {
      console.log("error", error);
    }
    window.location.replace("https://optionsgeek.com/log-out/");
  };

  fetchNews = (ticker) => fetchNewsFunc(ticker, this.props.setAppStateAction);

  fetchOpenInterest = (ticker) =>
    fetchOpenInterestFunc(
      ticker,
      this.props.appState,
      this.props.setAppStateAction
    );

  refreshOpenInterest = (ticker) => {
    if (ticker) {
      this.fetchOpenInterest(ticker);
      ReactGA.event({
        category: "OpenInterest",
        action: "Refreshed OI Data",
        label: `${ticker}`,
      });
    }
  };

  render() {
    const { loginLoader, logout } = this.props.appState;

    return (
      <div>
        {loginLoader ? (
          <Loading
            text={logout && logout === "true" ? "Logging out" : "Verifying"}
          />
        ) : (
          <Router>
            <Routes
              loginCheck={this.loginCheck}
              refreshOpenInterest={this.refreshOpenInterest}
              fetchNews={this.fetchNews}
              fetchOpenInterest={this.fetchOpenInterest}
            />
          </Router>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appState: state.appReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js